import React from 'react';
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { MaintenanceReportCategories } from '../MaintenanceReportCategories';
import { Layout } from '@singularsystems/neo-canvas-grid';
import CheckQueriesNotRunLastDayReportCriteria from './CheckQueriesNotRunLastDayReportCriteria';
import { AppService, Types } from '../../../App/Services/AppService';

@NeoReport("CheckQueriesNotRunLastDay",  { category: MaintenanceReportCategories.SystemInformationReports})
export default class CheckQueriesNotRunLastDayReport extends Report<CheckQueriesNotRunLastDayReportCriteria>{
    constructor(
        public serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient)
    ) {
        super(CheckQueriesNotRunLastDayReportCriteria);
    }

    public renderCriteria() {
        return (
        <>
        </>);
    }

    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}